import React, { FC } from 'react';
import classNames from 'classnames';

import Avatar, { IAvatarProps } from '@sv-support-sdk/ui-components/src/components/Media/Avatar';

import AccountPanelTag from './AccountPanelTag';

import css from './style.module.scss';

interface IProps {
  tag?: string;
  type?: 'secondary' | 'content';
  avatar?: IAvatarProps;
  title: string;
  subtitle?: string;
  info?: string;
  className?: string;
  [restProps: string]: any;
}

const AccountPanel: FC<IProps> = ({
  tag = 'button',
  type,
  avatar,
  title,
  subtitle,
  info,
  className,
  ...restProps
}) => {
  return (
    <AccountPanelTag
      tag={tag}
      className={classNames(
        css.accountPanel,
        {
          [css[`accountPanel_type_${type}`]]: type,
        },
        className,
      )}
      {...restProps}
    >
      <span className={css.accountPanel__content}>
        <span className={css.accountPanel__avatar}>
          <Avatar {...avatar} />
        </span>
        <span className={css.accountPanel__details}>
          <span className={css.accountPanel__title}>
            {title}
            {subtitle && <span className={css.accountPanel__subtitle}>{subtitle}</span>}
          </span>
          <span className={css.accountPanel__info}>{info}</span>
        </span>
      </span>
    </AccountPanelTag>
  );
};

export default AccountPanel;
